'use client';

import { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useTranslatedText } from './TranslatedText';

export default function ReviewCardExpandable({
  text,
  locale = 'en',
  readMoreLabel = 'Read more',
  showLessLabel = 'Show less',
}: {
  text: string;
  locale?: string;
  readMoreLabel?: string;
  showLessLabel?: string;
}) {
  const [expanded, setExpanded] = useState(false);
  const { displayText, translating } = useTranslatedText(text, locale);

  return (
    <div className="relative">
      {translating ? (
        <p className="text-sm leading-relaxed text-[#5A5A6E] flex items-center gap-2">
          <Loader2 className="w-3.5 h-3.5 animate-spin" />
        </p>
      ) : (
        <p className={cn('text-sm leading-relaxed text-[#1A1A2E]', !expanded && 'line-clamp-3')}>
          &ldquo;{displayText}&rdquo;
        </p>
      )}
      {displayText.length > 140 && (
        <button
          onClick={() => setExpanded(!expanded)}
          className="text-xs font-medium mt-1 cursor-pointer text-[#9B7B3A] hover:text-[#7a5f2b]"
        >
          {expanded ? showLessLabel : readMoreLabel}
        </button>
      )}
    </div>
  );
}
